import type { AurricaAppConfig } from './aurrica-app-config.types';

/** Default local / `dev` branch / development Nx configuration. */
export const AURRICA_APP_CONFIG: AurricaAppConfig = {
  deployEnvironment: 'development',
  githubUpdaterBranch: 'dev',
  freightAppUrl: 'https://freight.dev.aurrica.com',
  fleetAppUrl: 'https://fleet.dev.aurrica.com',
  ituranFleetSsoBase:
    'https://apolloqa.ituran.com/iweb2/DirectLoginSSO.aspx?cid=Aurrica',
  baseApi: 'https://api.dev.aurrica.com',
  assetsHost: 'https://assets.dev.aurrica.com',
  clientId: '2s5absneu8ro6u553f46mbg9id',
  poolId: 'us-east-1_QanyvBRR9',
  identityPoolId: 'us-east-1:ebf86a5a-018f-4b5b-80c7-8624e1bd6ce0',
  host: 'a2v9qht10gor60-ats.iot.us-east-1.amazonaws.com',
  routesAPIKey: 'AIzaSyAB5r6cwvVrQLyIXo6Kr6rqTUcfVqvBuvk',
  region: 'us-east-1',
  operational_countries: [
    'UG',
    'RW',
    'TZ',
    'SS',
    'CD',
    'BI',
    'ZM',
    'MW',
    'ZW',
    'MZ',
    'CM',
    'TD',
    'CF',
    'GA',
    'CG',
  ],
  firebaseConfig: {
    apiKey: 'AIzaSyDdowQ1hBsluE4YQfnlGnCpVB3zmFSE94Q',
    authDomain: 'aurrica-fleet-management.firebaseapp.com',
    projectId: 'aurrica-fleet-management',
    storageBucket: 'aurrica-fleet-management.firebasestorage.app',
    messagingSenderId: '1058734534935',
    appId: '1:1058734534935:web:591285bfd92c9d7790c752',
    measurementId: 'G-F0YGBDC7QW',
  },
  firebaseVapiKey:
    'BHOpe9RjCeOWaCd2mvSa16rSZqMDmTzjsibA0woasTtncYPSnXOEq9E6_SG9jVxQy-AkT-xiX5z9mH31lUc1nlM',
};
